__turbopack_context__.v({
  "body": "jlObWq_body",
  "card": "jlObWq_card",
  "cardLink": "jlObWq_cardLink",
  "date": "jlObWq_date",
  "image": "jlObWq_image",
  "imageWrapper": "jlObWq_imageWrapper",
  "meta": "jlObWq_meta",
  "title": "jlObWq_title",
});
